<template>
  <div class="br2-l ba b--black-10 pv4 mv2 mv3-l w-100 w-60-m w-35-l mw6 center bg-white items-center flex flex-column justify-center">
    <spinner/>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner.vue'

export default {
  components: {
    Spinner
  }
}
</script>

<style lang="scss" scoped>
</style>
